'use es6';

import LocalStorageCache from '../../util/LocalStorageCache';
import { ActionTypes } from '../../constants/AppConstants';
import themes from '../themes';
import produce from 'immer';
var cache = new LocalStorageCache({
  storageKey: 'theme'
});
var theme = cache.get();
var defaultState = {
  theme: theme || themes.halloween.name
};
export var themeReducer = produce(function (draftState, action) {
  switch (action.type) {
    case ActionTypes.APPLY_THEME:
      cache.put(action.payload.theme);

      if (action.payload.theme === 'halloween') {
        draftState.theme = themes.halloween.name;
      } else {
        draftState.theme = themes.defaultTheme.name;
      }

      return draftState;

    default:
      return draftState;
  }
}, defaultState);